import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import BreadCrumb from '../../components/BreadCrumb';
import CutImage from '../../components/CutImage';
import DefaultButton from '../../components/DefaultButton';
import DefaultCreationForm, {
  DefaultCreationFormButtonGroup,
  DefaultCreationFormGroup,
} from '../../components/DefaultCreationForm';
import DefaultInput from '../../components/DefaultInput';
import { DefaultPageTitle } from '../../components/DefaultPageTitle';
import { UpdatedAtLabel } from '../../components/UpdatedAt';
import { DefaultTextArea } from '../../components/DefaultTextArea';
import { hideModal, showModal } from '../../helpers/modal';
import SelectCourse from './components/SelectCourse';
import { AiOutlineDown, AiOutlineUp } from 'react-icons/ai';
import {
  getCourse as getCourseService,
  updateCourse as updateCourseService,
  createCourse as createCourseService,
  changeCourseThumbnail as changeCourseThumbnailService,
  deleteCourse,
  changeTrailBanner,
} from '../../services/trails';
import Swal from 'sweetalert2';
import checkEmptyString from '../../helpers/check-empty-string';
import Select, { SingleValue } from 'react-select';

import Category from '../../models/category';
import Author from '../../models/author';
import { getAllAuthors } from '../../services/authors';
import Course from '../../models/course';
import {
  ThumbnailUploadContainer,
  CourseThumbnail,
  SortLessonsContainer,
  LessonSelectionContainer,
  CreateAndEditSerieContainer,
} from './style';
import { getAllCategories } from '../../services/categories';
import { getSegmentations } from '../../services/segmentation';
import { getExams } from '../../services/exams';
import Exam from '../../models/exam';
import TagCategory from '../../models/tagCategory';
import { getAllTagCategories } from '../../services/tag-categories';
import { AcceptanceTerm } from '../Terms';
import { getAllAcceptanceTerm } from '../../services/acceptance-term';

interface CreateAndEditSerieProps {
  serieId: string;
}

interface SegmentationsItems {
  segmentation_item_id: string;
  item: string;
}

const CreateAndEditSerie: React.FC = () => {
  const history = useHistory();
  const { serieId } = useParams<CreateAndEditSerieProps>();

  const [termId, setTermId] = useState('');
  const [terms, setTerms] = useState<{ value: string; label: string }[]>([]);

  const handleGetAllAcceptanceTerms = async (event?: React.FormEvent) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    const response = await getAllAcceptanceTerm();

    response.map(item =>
      setTerms(oldArray => [
        ...oldArray,
        { value: item.id, label: item.title },
      ]),
    );
  };

  useEffect(() => {
    handleGetAllAcceptanceTerms();
  }, []);

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [introductionDuration, setIntroductionDuration] = useState(0);
  const [selectedCourses, setSelectedCourses] = useState([] as Course[]);

  const [cargo, setCargo] = useState([] as SegmentationsItems[]);
  const [loja, setLoja] = useState([] as SegmentationsItems[]);

  const [thumbnailFileToUpload, setThumbnailFileToUpload] = useState<File>();
  const [thumbnail, setThumbnail] = useState('');

  const [selectedExam, setSelectedExam] = useState(
    {} as { label: string; value: string },
  );
  const [exams, setExams] = useState([] as Exam[]);

  const [categories, setCategories] = useState([] as Category[]);
  const [tagsCategories, setTagsCategories] = useState([] as TagCategory[]);
  const [selectedCargo, setSelectedCargo] = useState(
    [] as unknown as { label: string; value: string }[],
  );
  const [selectedLoja, setSelectedLoja] = useState(
    [] as unknown as { label: string; value: string }[],
  );
  const [selectedCategory, setSelectedCategory] = useState(
    {} as { label: string; value: string },
  );

  const [selectedTagCategory, setSelectedTagCategory] = useState(
    {} as { label: string; value: string },
  );

  const [authors, setAuthors] = useState([] as Author[]);
  const [selectedAuthors, setSelectedAuthors] = useState(
    [] as { label: string; value: string }[],
  );

  const [bannerFileToUpload, setBannerFileToUpload] = useState<File>();
  const [banner, setBanner] = useState('');
  const [updatedAt, setUpdatedAt] = useState('');

  const createCourse = async (event: React.FormEvent) => {
    event.preventDefault();

    try {
      if (checkEmptyString(name)) {
        throw new Error('Informe um nome válido para o Curso.');
      }

      if (!selectedCourses || !selectedCourses.length) {
        throw new Error('Selecione um ou mais módulos antes.');
      }

      if (!Object.keys(selectedCategory).length) {
        throw new Error('Selecione uma categoria antes.');
      }

      if (!selectedTagCategory.value) {
        throw new Error('Selecione uma trilha antes.');
      }

      selectedCargo.forEach(cargo => {
        selectedLoja.forEach(loja => {
          if (cargo.label === loja.label) {
            throw new Error('O cargo precisa ser diferente do setor.');
          }
        });
      });

      const segmentation_items = [
        ...selectedCargo.map(s => ({ segmentation_item_id: s.value })),
        ...selectedLoja.map(s => ({ segmentation_item_id: s.value })),
      ];

      let createCourseData;

      if (segmentation_items.length) {
        createCourseData = {
          name: name,
          description: description.trim().length ? description : undefined,
          courses: selectedCourses.map((content, index) => ({
            course_id: content.course_id,
            position: index + 1,
          })),
          info: {
            video_reference_duration: introductionDuration,
            term_id: termId || undefined,
          },
          authors:
            selectedAuthors && selectedAuthors.length
              ? selectedAuthors.map((a: any) => ({ author_id: a.value }))
              : undefined,
          categories: [{ category_id: selectedCategory.value }],
          tag_categories: [{ tag_category_id: selectedTagCategory.value }],
          segmentation_items: segmentation_items,
          exam_id:
            selectedExam && selectedExam.value ? selectedExam.value : undefined,
        };
      } else {
        createCourseData = {
          name: name,
          description: description.trim().length ? description : undefined,
          courses: selectedCourses.map((content, index) => ({
            course_id: content.course_id,
            position: index + 1,
          })),
          info: {
            video_reference_duration: introductionDuration,
            term_id: termId || undefined,
          },
          authors:
            selectedAuthors && selectedAuthors.length
              ? selectedAuthors.map((a: any) => ({ author_id: a.value }))
              : undefined,
          categories: [{ category_id: selectedCategory.value }],
          tag_categories: [{ tag_category_id: selectedTagCategory.value }],
          exam_id:
            selectedExam && selectedExam.value ? selectedExam.value : undefined,
        };
      }
      const createdCourse = await createCourseService(createCourseData);

      if (thumbnailFileToUpload) {
        try {
          await changeCourseThumbnail(
            thumbnailFileToUpload,
            createdCourse.trail_id,
          );
        } catch (error) {
          await deleteCourse(createdCourse.trail_id);

          throw new Error(
            'Erro ao fazer upload da imagem de capa. Certifique-se de que a imagem selecionada não ultrapasse os 5MB.',
          );
        }
      }

      if (bannerFileToUpload) {
        try {
          await changeSerieBanner(bannerFileToUpload, createdCourse.trail_id);
        } catch (error) {
          await deleteCourse(createdCourse.trail_id);

          throw new Error(
            'Erro ao fazer upload da imagem de capa. Certifique-se de que a imagem selecionada não ultrapasse os 5MB.',
          );
        }
      }

      Swal.fire({
        title: 'Sucesso!',
        text: 'Curso criada com sucesso!',
        icon: 'success',
      });

      goToCourses();
    } catch (error) {
      Swal.fire({
        title: 'Erro',
        text: 'Houve um erro ao criar a curso. ' + error.message,
        icon: 'error',
      });
    }
  };

  const updateCourse = async (event: React.FormEvent) => {
    event.preventDefault();

    try {
      if (checkEmptyString(name)) {
        throw new Error('Informe um nome válido para a curso.');
      }

      if (!selectedCourses || !selectedCourses.length) {
        throw new Error('Selecione um ou mais módulos antes.');
      }

      if (!selectedCategory) {
        throw new Error('Selecione uma categoria antes.');
      }

      if (!selectedTagCategory.value) {
        throw new Error('Selecione uma trilha antes.');
      }

      selectedCargo.forEach(cargo => {
        selectedLoja.forEach(loja => {
          if (cargo.label === loja.label) {
            throw new Error('O cargo precisa ser diferente do setor.');
          }
        });
      });
      const segmentation_items = [
        ...selectedCargo.map(s => ({ segmentation_item_id: s.value })),
        ...selectedLoja.map(s => ({ segmentation_item_id: s.value })),
      ];

      let createCourseData;

      if (segmentation_items.length) {
        createCourseData = {
          name: name,
          description: (description || '').trim().length
            ? description
            : undefined,
          courses: selectedCourses.map((content, index) => ({
            course_id: content.course_id,
            position: index + 1,
          })),
          info: {
            video_reference_duration: introductionDuration,
            term_id: termId || undefined,
          },
          authors:
            selectedAuthors && selectedAuthors.length
              ? selectedAuthors.map((a: any) => ({ author_id: a.value }))
              : undefined,
          categories: [{ category_id: selectedCategory.value }],
          segmentation_items: segmentation_items,
          tag_categories: [{ tag_category_id: selectedTagCategory.value }],
          exam_id:
            selectedExam && selectedExam.value ? selectedExam.value : undefined,
        };
      } else {
        createCourseData = {
          name: name,
          description: (description || '').trim().length
            ? description
            : undefined,
          courses: selectedCourses.map((content, index) => ({
            course_id: content.course_id,
            position: index + 1,
          })),
          info: {
            video_reference_duration: introductionDuration,
            term_id: termId || undefined,
          },
          authors:
            selectedAuthors && selectedAuthors.length
              ? selectedAuthors.map((a: any) => ({ author_id: a.value }))
              : undefined,
          categories: [{ category_id: selectedCategory.value }],
          tag_categories: [{ tag_category_id: selectedTagCategory.value }],
          exam_id:
            selectedExam && selectedExam.value ? selectedExam.value : undefined,
        };
      }

      await updateCourseService(serieId, createCourseData);

      if (thumbnailFileToUpload) {
        try {
          await changeCourseThumbnail(thumbnailFileToUpload, serieId);
        } catch (error) {
          throw new Error(
            'Erro ao fazer upload da imagem de capa. Certifique-se de que a imagem selecionada não ultrapasse os 5MB.',
          );
        }
      }

      if (bannerFileToUpload) {
        try {
          await changeSerieBanner(bannerFileToUpload, serieId);
        } catch (error) {
          throw new Error(
            'Erro ao fazer upload da imagem do banner. Certifique-se de que a imagem selecionada não ultrapasse os 5MB.',
          );
        }
      }

      Swal.fire({
        title: 'Sucesso!',
        text: 'curso editada com sucesso!',
        icon: 'success',
      });

      goToCourses();
    } catch (error) {
      Swal.fire({
        title: 'Erro',
        text: 'Houve um erro ao editar a curso. ' + error.message,
        icon: 'error',
      });
    }
  };

  const changeCourseThumbnail = async (
    localThumbnailFileToUpload: File,
    localSerieId: string,
  ) => {
    const formData = new FormData();
    formData.append('file', localThumbnailFileToUpload);
    formData.append(
      'name',
      `course_thumbnail_${localSerieId}.${localThumbnailFileToUpload.type}`,
    );
    formData.append('description', `thumbnail da curso de id ${localSerieId}`);

    await changeCourseThumbnailService(localSerieId, formData);
  };

  const changeSerieBanner = async (
    localBannerFileToUpload: File,
    localSerieId: string,
  ) => {
    const formData = new FormData();
    formData.append('file', localBannerFileToUpload);
    formData.append(
      'name',
      `content_thumbnail_${localSerieId}.${localBannerFileToUpload.type}`,
    );
    formData.append(
      'description',
      `thumbnail do conteúdo de id ${localSerieId}`,
    );

    await changeTrailBanner(localSerieId, formData);
  };

  const selectCourses = () => {
    showModal(
      'Selecionar',
      <SelectCourse
        onApplySelection={applyCoursesSelection}
        selectedCourses={[...selectedCourses]}
      />,
    );
  };

  const selectImage = (isThumb: boolean) => {
    if (isThumb) {
      showModal(
        'Selecionar Imagem de Capa',
        <CutImage
          aspect={1.812}
          onCutImage={(file: File) => onCutImage(file, isThumb)}
        />,
      );
    } else {
      showModal(
        'Selecionar Imagem',
        <CutImage
          aspect={1.812}
          onCutImage={(file: File) => onCutImage(file, isThumb)}
        />,
      );
    }
  };

  const onCutImage = (file: File, isThumb: boolean) => {
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      if (isThumb) {
        setThumbnailFileToUpload(file);

        reader.onload = () => setThumbnail(`${reader.result}`);
      }

      hideModal();
    }
  };

  const applyCoursesSelection = (localSelectedCourses: Course[]) => {
    hideModal();

    if (localSelectedCourses) {
      setSelectedCourses(localSelectedCourses);
    }
  };

  const reorderSelectedCourses = (lesson: Course, up: boolean) => {
    if (selectedCourses) {
      const localSelectedCourses = [...selectedCourses];
      const indexOfLesson = localSelectedCourses.indexOf(lesson);
      if (indexOfLesson > -1 && indexOfLesson < localSelectedCourses.length) {
        localSelectedCourses.splice(indexOfLesson, 1);
        if (up) {
          localSelectedCourses.splice(indexOfLesson - 1, 0, lesson);
        } else {
          localSelectedCourses.splice(indexOfLesson + 1, 0, lesson);
        }
      }

      setSelectedCourses(localSelectedCourses);
    }
  };

  const getCourse = useCallback(async () => {
    const foundAuthors = await getAllAuthors();
    const foundCategories = await getAllCategories({ is_active: true });
    const foundSegmentations = await getSegmentations();
    const foundExams = await getExams();
    const foundTagsCategories = await getAllTagCategories({ is_active: true });

    setExams((foundExams || []).filter(exam => exam.enabled));
    if (foundAuthors) {
      setAuthors(foundAuthors);
    }
    if (foundCategories) {
      setCategories(foundCategories);
    }
    if (foundTagsCategories) {
      setTagsCategories(foundTagsCategories);
    }

    if (foundSegmentations) {
      foundSegmentations.map((segmentation: any) => {
        if (segmentation.type === 'Cargo') {
          setCargo(segmentation.items);
        }
        if (segmentation.type === 'Setor') {
          setLoja(segmentation.items);
        }
      });
    }
    if (serieId && serieId !== 'as') {
      const course = await getCourseService(serieId);

      if (course && Object.keys(course).length) {
        setName(course.trail.name);
        setDescription(course.trail.description);
        setSelectedCourses(
          course.trail.courses && course.trail.courses.length
            ? course.trail.courses.sort((a: any, b: any) =>
                a.position > b.position ? 1 : -1,
              )
            : [],
        );
        setThumbnail(course.trail.thumbnail);
        setBanner(course.trail.info && course.trail.info.banner);
        setTermId(course.trail.info.term_id);

        if (course.trail.info && course.trail.info.video_reference_duration) {
          setIntroductionDuration(course.trail.info.video_reference_duration);
        }

        if (course.trail?.updated_at) {
          let date = new Date(course.trail.updated_at);
          setUpdatedAt(date.toLocaleString());
        }

        if (
          course.trail.segmentations &&
          course.trail.segmentations[0] !== null
        ) {
          course.trail.segmentations.map((segmentation: any) => {
            if (segmentation.type === 'Cargo') {
              setSelectedCargo(
                segmentation.items.map((segItem: any) => ({
                  label: segItem.item,
                  value: segItem.segmentation_item_id,
                })),
              );
            }
            if (segmentation.type === 'Setor') {
              setSelectedLoja(
                segmentation.items.map((segItem: any) => ({
                  label: segItem.item,
                  value: segItem.segmentation_item_id,
                })),
              );
            }
          });
        }

        const courseExam =
          typeof course.trail.exam === 'object'
            ? (foundExams || []).find(
                (exam: any) => exam.id === course.trail.exam.examId,
              ) || ({} as Exam)
            : (foundExams || []).find(
                (exam: any) => exam.id === course.trail.exam,
              ) || ({} as Exam);

        if (courseExam) {
          setSelectedExam({ label: courseExam.title, value: courseExam.id });
        }

        setSelectedCategory({
          label: course.trail.category.title,
          value: course.trail.category.id,
        });

        setSelectedAuthors(
          course.trail && course.trail.authors && course.trail.authors.length
            ? course.trail.authors.map((a: any) => ({
                label: a.name,
                value: a.id,
              }))
            : [],
        );
      }
    }
  }, [serieId]);

  const cargoToBeSelected = useMemo(() => {
    if (cargo && cargo.length) {
      return cargo.map(cargo => ({
        label: cargo.item,
        value: `${cargo.segmentation_item_id}`,
      }));
    }

    return [] as { label: string; value: string }[];
  }, [cargo]);

  const lojaToBeSelected = useMemo(() => {
    if (loja && loja.length) {
      return loja.map(loja => ({
        label: loja.item,
        value: `${loja.segmentation_item_id}`,
      }));
    }

    return [] as { label: string; value: string }[];
  }, [loja]);

  const authorsToBeSelected = useMemo(() => {
    if (authors && authors.length) {
      return authors.map(author => ({
        label: author.name,
        value: `${author.author_id}`,
      }));
    }

    return [] as { label: string; value: string }[];
  }, [authors]);

  const categoriesToBeSelected = useMemo(() => {
    if (categories && categories.length) {
      return categories.map(category => ({
        label: category.title,
        value: `${category.category_id}`,
      }));
    }

    return [] as { label: string; value: string }[];
  }, [categories]);

  const tagsCategoriesToBeSelected = useMemo(() => {
    if (tagsCategories && tagsCategories.length) {
      return tagsCategories.map(tagCategory => ({
        label: tagCategory.title,
        value: `${tagCategory.tag_category_id}`,
      }));
    }

    return [] as { label: string; value: string }[];
  }, [tagsCategories]);

  const examsToBeSelected = useMemo(() => {
    let examsToBeReturned = [
      { label: 'Selecione uma prova para este curso', value: '' },
    ] as {
      label: string;
      value: string;
    }[];

    if (exams && exams.length) {
      examsToBeReturned.push(
        ...exams.map(exam => ({
          label: exam.title,
          value: `${exam.id}`,
        })),
      );
    }

    return examsToBeReturned;
  }, [exams]);

  const goToCourses = () => {
    history.push('/course/series');
  };

  useEffect(() => {
    getCourse();
  }, [getCourse]);

  const isEditting = useMemo(() => {
    if (serieId) {
      return true;
    }

    return false;
  }, [serieId]);

  function handleTermId(
    newValue: SingleValue<{ value: string; label: string }>,
  ) {
    setTermId(newValue?.value!);
  }

  return (
    <CreateAndEditSerieContainer>
      <BreadCrumb
        crumbs={[
          <Link to="/profile">Dashboard</Link>,
          <Link to="/course/series">Cursos</Link>,
          <span>{isEditting ? 'Editar' : 'Criar'} Curso</span>,
        ]}
      />

      <DefaultPageTitle>
        {isEditting ? 'Editar' : 'Criar'} Curso
        {updatedAt && (
          <UpdatedAtLabel> - Última atualização em {updatedAt}</UpdatedAtLabel>
        )}
      </DefaultPageTitle>

      <DefaultCreationForm>
        <DefaultCreationFormGroup>
          <label className="required" htmlFor="title">
            Título
          </label>
          <DefaultInput
            value={name}
            onChange={e => setName(e.target.value)}
            id="title"
            required
          />
        </DefaultCreationFormGroup>

        <DefaultCreationFormGroup>
          <label htmlFor="description">Descrição</label>
          <DefaultTextArea
            value={description || ''}
            onChange={e => setDescription(e.target.value)}
            id="description"
          />
        </DefaultCreationFormGroup>

        <DefaultCreationFormGroup>
          <label className="required" htmlFor="reference">
            Módulos
          </label>

          <LessonSelectionContainer>
            {selectedCourses && selectedCourses.length ? (
              <SortLessonsContainer>
                {selectedCourses.map((lesson, index) => (
                  <div key={lesson.course_id} className="selected-lessons">
                    <div className="buttons">
                      {index > 0 ? (
                        <DefaultButton
                          type="button"
                          title="Subir Aula"
                          className="small white up"
                          onClick={() => reorderSelectedCourses(lesson, true)}
                        >
                          <AiOutlineUp />
                        </DefaultButton>
                      ) : (
                        <></>
                      )}
                      {index < selectedCourses.length - 1 ? (
                        <DefaultButton
                          type="button"
                          title="Descer Aula"
                          className="small white down"
                          onClick={() => reorderSelectedCourses(lesson, false)}
                        >
                          <AiOutlineDown />
                        </DefaultButton>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="lesson-title">
                      {index + 1} - {lesson.title}
                    </div>
                  </div>
                ))}
              </SortLessonsContainer>
            ) : (
              <></>
            )}
            <DefaultButton type="button" onClick={selectCourses}>
              Selecionar
            </DefaultButton>
          </LessonSelectionContainer>
        </DefaultCreationFormGroup>

        <DefaultCreationFormGroup>
          <label htmlFor="reference">
            Capa
            <br />
            <li>
              Precisa ter a largura máxima de 1.280px e altura máxima de 417px
            </li>
          </label>

          <ThumbnailUploadContainer>
            <DefaultButton type="button" onClick={() => selectImage(true)}>
              Selecionar Imagem de Capa
            </DefaultButton>

            {thumbnail && <CourseThumbnail src={thumbnail} />}
          </ThumbnailUploadContainer>
        </DefaultCreationFormGroup>

        <DefaultCreationFormGroup>
          <label htmlFor="exam">Prova</label>
          <Select
            styles={{
              container: provided => ({
                ...provided,
                flexGrow: 1,
                width: '100%',
              }),
            }}
            options={examsToBeSelected}
            value={selectedExam}
            onChange={option =>
              option &&
              setSelectedExam(() => ({
                label: option.label,
                value: option.value,
              }))
            }
            id="exam"
          />
        </DefaultCreationFormGroup>

        <DefaultCreationFormGroup>
          <label htmlFor="tags">Autores</label>
          <Select
            isMulti
            styles={{
              container: provided => ({
                ...provided,
                flexGrow: 1,
                width: '100%',
              }),
            }}
            options={authorsToBeSelected}
            value={selectedAuthors}
            onChange={options => {
              options &&
                !window.isNaN(options.length) &&
                setSelectedAuthors(
                  options.map(o => ({
                    label: o.label,
                    value: o.value,
                  })) as any,
                );
            }}
            id="authors"
            placeholder="Selecione um autor para esta série."
          />
        </DefaultCreationFormGroup>
        <DefaultCreationFormGroup>
          <label className="required" htmlFor="tags">
            Categoria
          </label>
          <Select
            styles={{
              container: provided => ({
                ...provided,
                flexGrow: 1,
                width: '100%',
              }),
            }}
            options={categoriesToBeSelected}
            value={selectedCategory}
            onChange={options => {
              options &&
                setSelectedCategory({
                  label: options.label,
                  value: options.value,
                });
            }}
            id="categories"
            placeholder="Selecione uma categoria para este conteúdo."
          />
        </DefaultCreationFormGroup>

        <DefaultCreationFormGroup>
          <label className="required" htmlFor="tags">
            Trilha
          </label>
          <Select
            styles={{
              container: provided => ({
                ...provided,
                flexGrow: 1,
                width: '100%',
              }),
            }}
            options={tagsCategoriesToBeSelected}
            value={selectedTagCategory}
            onChange={options => {
              options &&
                setSelectedTagCategory({
                  label: options.label,
                  value: options.value,
                });
            }}
            id="tagCategories"
            placeholder="Selecione uma trilha para este conteúdo."
          />
        </DefaultCreationFormGroup>

        <DefaultCreationFormGroup>
          <label htmlFor="tags">Cargo</label>
          <Select
            styles={{
              container: provided => ({
                ...provided,
                flexGrow: 1,
                width: '100%',
              }),
            }}
            options={cargoToBeSelected}
            value={selectedCargo}
            onChange={(options: any) =>
              options &&
              !window.isNaN(options.length) &&
              setSelectedCargo(
                options.map((opt: any) => ({
                  label: opt.label,
                  value: opt.value,
                })),
              )
            }
            isMulti
            id="categories"
            placeholder="Selecione os cargos que poderão visualizar o curso."
          />
        </DefaultCreationFormGroup>

        <DefaultCreationFormGroup>
          <label htmlFor="tags">Setor</label>
          <Select
            styles={{
              container: provided => ({
                ...provided,
                flexGrow: 1,
                width: '100%',
              }),
            }}
            options={lojaToBeSelected}
            value={selectedLoja}
            onChange={(options: any) =>
              options &&
              !window.isNaN(options.length) &&
              setSelectedLoja(
                options.map((opt: any) => ({
                  label: opt.label,
                  value: opt.value,
                })),
              )
            }
            isMulti
            id="categories"
            placeholder="Selecione as lojas que poderão visualizar o curso."
          />
        </DefaultCreationFormGroup>

        <DefaultCreationFormGroup>
          <label htmlFor="tags">Termos</label>
          <Select
            styles={{
              container: provided => ({
                ...provided,
                flexGrow: 1,
                width: '100%',
              }),
            }}
            noOptionsMessage={() => 'No option was found'}
            menuPlacement="auto"
            className="react-select-container"
            classNamePrefix="react-select"
            isDisabled={false}
            isLoading={false}
            isClearable={true}
            isRtl={false}
            isSearchable={true}
            onChange={handleTermId}
            options={terms}
            placeholder="Selecione um termo para esse curso."
            value={terms.filter(t => t.value === termId)}
          />
        </DefaultCreationFormGroup>

        <DefaultCreationFormButtonGroup>
          <DefaultButton type="button" className="danger" onClick={goToCourses}>
            Cancelar
          </DefaultButton>
          <DefaultButton
            onClick={e => (isEditting ? updateCourse(e) : createCourse(e))}
            className="success"
          >
            Salvar
          </DefaultButton>
        </DefaultCreationFormButtonGroup>
      </DefaultCreationForm>
    </CreateAndEditSerieContainer>
  );
};

export default CreateAndEditSerie;
